// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import { format } from "../utils/format";
import Select, { getOption } from '../form/select.js';
import GroupedSelect from '../form/grouped-select.js';
import AddCardBtn from '../card/add-new-card.block.js';
import SortableTh from '../sorting/sortable-th.js';
import { defaultSorting } from '../sorting/sorting.const.js';
import { sortStringOrNumber } from '../sorting/sorting.model.js';

import type { MapStateToProps } from 'react-redux';

import LoadingIndicator from '../ui/loading-indicator.js';
import { ADD_CARD } from '../card/card.const.js';
import { payerSelector, userSelector } from '../user/user.selectors.js';

import Icon from '../icon/icon.js';

import { amountPattern } from '../payments/payments.const.js';

import {
  invoicesSelector,
  invoicesListSelector,
  invoicePaySelector,
  unpaidInvoicesListSelector
} from './invoice.selectors.js';

import {
  organizationsSelector,
  organizationsOptionsSelector
} from '../organization/organization.selectors.js';

import {
  transactionsSelector,
  transactionsListSelector,
  offlineTypeOptionsSelector,
  paymentTransactionsListSelector
} from '../transaction/transaction.selectors.js';
import { eventsSelector } from '../event/event.selectors.js';

import { BUY_TRANSACTION } from '../transaction/transaction.const.js';

import { buyTransaction, addOffline } from '../transaction/transaction.actions.js';

import { cardsSelector, cardsListSelector } from '../card/card.selectors.js';
import { addCard } from '../card/card.actions.js';

import { selectUIModal, selectUIProgress } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import { payInvoice } from './invoice.actions.js';

type OwnProps = {|
  showFilter: Boolean
|};

type MappedState = {|
  progress: boolean,
  modalBuy: boolean,
  invoices: $ElementType<ReduxState, 'invoices'>,
  transactions: $ElementType<ReduxState, 'transactions'>,
  transactionsList: $ElementType<ReduxState, 'transactionsList'>,
  cards: $ElementType<ReduxState, 'cards'>,
  cardsList: $ElementType<ReduxState, 'cardsList'>,
  invoicePay: $ElementType<ReduxState, 'invoicePay'>,
  invoiceProducts: $ElementType<ReduxState, 'invoiceProducts'>,
  invoiceProductsList: List,
  invoiceResources: $ElementType<ReduxState, 'invoiceResources'>,
  invoiceResourcesList: List
|};

type Props = {|
  ...OwnProps,
  ...MappedState,
  payInvoice: typeof payInvoice,
  buyTransaction: typeof buyTransaction,
  addOffline: typeof addOffline,
  setModal: typeof setModal,
  fieldAttrs: FieldAttrs
|};

class InvoicePayBlock extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filter: {
        organization: 'all',
        type: 'All'
      },
      sorting: defaultSorting
    };
    this.isCheckedInvoice = this.isCheckedInvoice.bind(this);
    this.onAddCard = this.onAddCard.bind(this);
    this.handleCheckInvoice = this.handleCheckInvoice.bind(this);
    this.onAddCardOpen = this.onAddCardToggle.bind(this, true);
    this.onAddCardClose = this.onAddCardToggle.bind(this, false);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.setSorting = this.setSorting.bind(this);
    this.filterSortingUnpaidInvoicesList = this.filterSortingUnpaidInvoicesList.bind(this);
  }

  onAddCardOpen: Function;
  onAddCardClose: Function;
  handlePaymentCheck: Function;

  onAddCardToggle(state: boolean) {
    this.props.setModal(state, ADD_CARD);
    return true;
  }

  handlePaymentCheck() {
    const findPaymentBtn = document.querySelector('.Select-input > input');
    if (findPaymentBtn) {
      findPaymentBtn.focus();
    }
    return true;
  }

  isCheckedInvoice(invoiceId) {
    const { payForm } = this.props;
    const invoices = payForm.invoices;
    if (invoices) {
      return Object.keys(invoices).includes(invoiceId.toString());
    }
    return false;
  }

  handleCheckInvoice(invoiceId) {
    const { invoicePay } = this.props;
    const { checkedInvoices } = invoicePay;
    if (checkedInvoices.includes(invoiceId)) {
      this.props.fieldAttrs.onChange(
        'invoicePay.checkedInvoices',
        checkedInvoices.filter(value => value !== invoiceId)
      );
    } else {
      this.props.fieldAttrs.onChange(
        'invoicePay.checkedInvoices',
        checkedInvoices.concat(invoiceId)
      );
    }
  }


  onAddCard(stripe) {
    return this.props.addCard(stripe);
  }

  onFilterChange(e) {
    this.props.fieldAttrs.onChange({
      'invoicePay.paymantMethod': {},
      'invoicePay.organizationId': e.currentTarget.value
    });
    return this.setState({
      filter: {
        ...this.state.filter,
        [e.currentTarget.name]: e.currentTarget.value
      }
    });
  }

  setSorting(e: SyntheticInputEvent<HTMLElement>) {
    const { field } = e.currentTarget.dataset;
    return this.setState({
      sorting: {
        field,
        dir: this.state.sorting.dir === 'asc' ? 'desc' : 'asc'
      }
    });
  }

  filterSortingUnpaidInvoicesList() {
    const { filter, sorting } = this.state;
    const { unpaidInvoicesList, invoices, organizations, events } = this.props;
    const invoicesListFilter =
      filter.organization === 'all'
        ? unpaidInvoicesList
        : unpaidInvoicesList.filter(
            id => invoices[id].organizationId === parseInt(this.state.filter.organization, 10)
          );
    if (sorting.field === 'organizationId') {
      return sortStringOrNumber(invoicesListFilter, invoices, sorting, organizations, 'name');
    }
    if (sorting.field === 'eventId') {
      return sortStringOrNumber(invoicesListFilter, invoices, sorting, events, 'startTime');
    }
    return sortStringOrNumber(invoicesListFilter, invoices, sorting);
  }

  render() {
    const {
      URL,
      events,
      progress,
      invoices,
      transactions,
      cards,
      cardsList,
      offlineTypeOptions,
      fieldAttrs,
      invoicePay,
      user,
      payer,
      organizations,
      organizationsOptions,
      showFilter,
      paymentTransactionsList
    } = this.props;

    const {filter} = this.state;

    if (!invoices) return null;

    const total = invoicePay.checkedInvoices.reduce(
      (acc, value) => acc + parseFloat(invoicePay.invoices[value]) || 0,
      0
    );
    const totalReal = invoicePay.checkedInvoices.reduce(
      (acc, value) => acc + (invoices[value] && parseFloat(invoices[value].balance)) || 0,
      0
    );
    const cardsOptions = cardsList.map(cardId =>
      getOption(
        `${cards[cardId].brand} ending in ${format(
          cards[cardId].expirationDateTime,
          'Y'
        )}, exp. ${format(cards[cardId].expirationDateTime, 'm/d')}`,
        cardId,
        { type: 'cardId' }
      )
    );

    const transactionsOptions = paymentTransactionsList
      .filter(transactionId => {
          const currentTransaction = transactions[transactionId] || {};
          return filter.organization === 'all'
            || currentTransaction.organizationId === parseInt(filter.organization, 10)
        })
      .map(transactionId => {
        const currentTransaction = transactions[transactionId] || {};
        return getOption(
          `$${currentTransaction.amount} - Organization ${currentTransaction.incomeSourceType}`,
          transactionId,
          { type: 'transactionId' }
        )
      });

    const paylistGroup = [];

    if (cardsOptions.length) {
      paylistGroup.push(getOption('Cards', 'Cards', { disabled: true, isGroup: true }));
      paylistGroup.push(...cardsOptions);
    }
    if (transactionsOptions.length) {
      paylistGroup.push(
        getOption('Income transactions', 'income', { disabled: true, isGroup: true })
      );
      paylistGroup.push(...transactionsOptions);
    }
    const isYou = user.id === payer.id;
    if (URL.org && offlineTypeOptions.length) {
      paylistGroup.push(getOption('Offline', 'Offline', { disabled: true, isGroup: true }));
      paylistGroup.push(...offlineTypeOptions);
    }
    const notPayInvoices = !URL.org && this.state.filter.organization === 'all';
    const disabledPay =
      progress || total === 0 || !invoicePay.paymantMethod.type || (showFilter && notPayInvoices);

    const invoicesListFilter = this.filterSortingUnpaidInvoicesList();

    return (
      <React.Fragment>
        <div className="invoices-unpaid-block">
          <div className="heading-block">
            <div className="heading-block-name">
              <Icon width="12px" height="14px" name="card" className="icon-primary" />
              <span className="heading-text">All Unpaid Invoices</span>
            </div>
          </div>
          {showFilter && !URL.org ? (
            <React.Fragment>
              <div className="invoices-paid-block">
                <div className="panel panel-default invoices-filter-block">
                  <div className="filer-item filter-lebel">Filter by Organization</div>

                  <div className="filer-item select">
                    <Select
                      name="organization"
                      className="form-control"
                      options={organizationsOptions}
                      value={this.state.filter.organization}
                      onChange={this.onFilterChange}
                    />
                  </div>
                  {notPayInvoices ? <div>Select organization to make payment</div> : null}
                </div>
              </div>
            </React.Fragment>
          ) : null}
        </div>
        {invoicesListFilter.length ? (
          <div className="invoices-pay-wrap">
            <div className="invoices-pay-tabel table-responsive">
              <table className="table table-sm table-panel">
                <thead>
                  <tr>
                    <SortableTh
                      field="number"
                      name="invoicesSorting"
                      label="Invoice Number"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <SortableTh
                      field="userCreateTimestamp"
                      name="invoicesSorting"
                      label="Invoice Date"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <SortableTh
                      field="organizationId"
                      name="invoicesSorting"
                      label="Organization"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <SortableTh
                      field="eventId"
                      name="invoicesSorting"
                      label="Event Date"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <SortableTh
                      field="totalPrice"
                      name="invoicesSorting"
                      label="Total"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <SortableTh
                      field="balance"
                      name="invoicesSorting"
                      label="Balance"
                      sorting={this.state.sorting}
                      innerClassName="text-left"
                      onClick={this.setSorting}
                    />
                    <th>Amount Paid, $</th>
                  </tr>
                </thead>
                <tbody>
                  {invoicesListFilter.map(invoiceId => {
                    const invoice = invoices[invoiceId];
                    const event = events[invoice.eventId];
                    const isChecked = invoicePay.checkedInvoices.includes(invoiceId);
                    return (
                      <tr key={invoiceId}>
                        <td>
                          <input
                            type="checkbox"
                            id={`invoices-invoiceId-${invoiceId}`}
                            checked={isChecked}
                            disabled={progress}
                            onChange={() => this.handleCheckInvoice(invoiceId)}
                          />
                          <label
                            className="invoices-invoiceId-label"
                            htmlFor={`invoices-invoiceId-${invoiceId}`}
                          >
                            <b>Invoice #{invoice.number}</b>
                          </label>
                        </td>
                        <td>{format(invoice.userCreateTimestamp * 1000, 'd M Y')}</td>
                        <td>{organizations[invoice.organizationId].name}</td>
                        <td>
                          {event ? (
                            <a
                              target="_blank"
                              className="underline"
                              href={`${window.serverData._uri}/org/${organizations[invoice.organizationId].unique}${event.link}`}
                            >
                              {event.period}
                            </a>
                          ) : (
                            'Created not from an event'
                          )}
                        </td>
                        <td>
                          <var>${invoice.totalPrice}</var>
                        </td>
                        <td>
                          <var>${invoice.balance}</var>
                        </td>
                        <td>
                          <input
                            className="invoices-paid-mount-input"
                            type="text"
                            pattern={amountPattern}
                            name={`invoicePay.invoices.${invoiceId}`}
                            value={invoicePay.invoices[invoiceId]}
                            disabled={progress}
                            {...fieldAttrs}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {showFilter && notPayInvoices ? null : (
              <div className="invoices-pay-controls">
                <b className="invoices-pay-controls-strong">Select payment method</b>
                <input
                  ref={e => (this.check = e)}
                  onChange={this.handlePaymentCheck}
                  type="checkbox"
                  id="paylist-group-input-for-modal"
                />
                <div className="paylist-group-label-section-wrap">
                  <label
                    className="paylist-group-label-wrap"
                    htmlFor="paylist-group-input-for-modal"
                  >
                    <span>{invoicePay.paymantMethod.label || 'Select payment method'}</span>
                    <div className="paylist-group-label-triangle" />
                  </label>
                  <div className="paylist-group-modal">
                    <label
                      className="paylist-group-modal-label"
                      htmlFor="paylist-group-input-for-modal"
                    >
                      +
                    </label>
                    <GroupedSelect
                      openOnFocus={true}
                      autofocus={true}
                      searchable
                      clearable={false}
                      removeSelected={false}
                      placeholder="Find payment"
                      options={paylistGroup}
                      value={invoicePay.paymantMethod.value}
                      onChange={value => {
                        if (value) {
                          fieldAttrs.onChange('invoicePay.paymantMethod', { value });
                          this.check.checked = false;
                        }
                      }}
                    />
                  </div>
                </div>
                {isYou ? <AddCardBtn widthIcon /> : null}
                <div className="info-total-wrap">
                  <div className="pay-invoce-info-total">
                    <span>Total</span> <span>${total.toFixed(2)}</span>
                  </div>
                  <div className="pay-invoce-info-btn-wrap">
                    <button
                      className="btn btn-success btn-success-pay-invoice"
                      disabled={disabledPay}
                      onClick={() => this.props.payInvoice()}
                    >
                      Pay
                      {progress ? <LoadingIndicator /> : null}
                    </button>
                    {total !== totalReal ? (
                      <span>
                        Will be paid <b>{total.toFixed(2)}</b> from <b>${totalReal.toFixed(2)}</b>
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const modalBuySelector = selectUIModal(BUY_TRANSACTION);
const progressSelector = selectUIProgress();
const addCardModalSelector = selectUIModal(ADD_CARD);

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  URL: state.URL,
  progress: progressSelector(state),
  modalBuy: modalBuySelector(state),
  invoices: invoicesSelector(state),
  invoicesList: invoicesListSelector(state),
  unpaidInvoicesList: unpaidInvoicesListSelector(state),
  transactions: transactionsSelector(state),
  transactionsList: transactionsListSelector(state),
  paymentTransactionsList: paymentTransactionsListSelector(state),
  cards: cardsSelector(state),
  cardsList: cardsListSelector(state),
  organizations: organizationsSelector(state),
  invoicePay: invoicePaySelector(state),
  events: eventsSelector(state),
  user: userSelector(state),
  payer: payerSelector(state),
  offlineTypeOptions: offlineTypeOptionsSelector(state),
  addCardModal: addCardModalSelector(state),
  organizationsOptions: organizationsOptionsSelector(state)
});

export default connect(
  mapStateToProps,
  {
    ...formActions,
    payInvoice,
    buyTransaction,
    setModal,
    addOffline,
    addCard
  },
  mergeActionsToProps
)(InvoicePayBlock);
